const attachment = {
  attachment: 'المرفقات',
  'attachment.attachment': 'المرفقات',
  'attachment.accepttext': 'يدعم تحميل ملفات xlsx/jpg/png/pdf، حجم الملف أقل من 10MB',
  'attachment.errsize': 'حجم الملف يجب أن يكون أقل من 10MB',
  'attachment.errtype': 'نوع الملف غير مدعوم',
  'attachment.uploadfile': 'رفع ملف',
};

export default attachment;
